<template>
  <div class="area-box" :style="{ borderColor: getAreaColor(level) }">
    <div class="area-title">
      {{ node.AreName }}
      <div v-if="node.mainPosition" class="main-position">
        <small>NIVEL {{ node.level }} : {{ node.mainPosition }} </small>
      </div>
    </div>
    <div class="puestos-list">
      <div class="puestos-list">
        <template v-if="primerPuestoConHijos">
          <PuestoTree :puesto="primerPuestoConHijos" />
        </template>
        <template
          v-else-if="
            node.puestos &&
              node.puestos.length &&
              node.puestos[0].name != node.mainPosition
          "
        >
          <div class="puesto-item">
            {{ node.puestos[0].name }} - NIVEL {{ node.puestos[0].level }}
          </div>
        </template>
      </div>
      <div class="subareas-list">
        <area-node
          v-for="child in node.children"
          :key="child.AreName"
          :node="child"
          :level="level + 1"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AreaNode",
  components: {
    PuestoTree: () => import("./PuestoTree.vue"),
  },
  computed: {
    primerPuestoConHijos() {
      return this.node.puestos.find((p) => p.children && p.children.length);
    },
  },
  props: {
    node: { type: Object, required: true },
    level: { type: Number, default: 0 },
  },
  methods: {
    getAreaColor(level) {
      const colors = [
        "#FFB6C1",
        "#B0E0E6",
        "#FFD700",
        "#90EE90",
        "#FFA07A",
        "#DDA0DD",
        "#87CEFA",
      ];
      return colors[level % colors.length];
    },
  },
  created() {
    // Asignar el puesto principal al nodo
    // console.log("Node:", this.node);
  },
};
</script>

<style scoped>
.area-box {
  border: 4px solid;
  border-radius: 16px;
  padding: 16px;
  margin: 16px;
  background: #fff;
  box-shadow: 0 2px 8px #0001;
  min-width: 220px;
}

.area-title {
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 12px;
  text-align: center;
}

.puestos-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.puesto-item {
  padding: 6px 12px;
  border-radius: 8px;
  background: #f6f6f6;
  border: 1px solid #eee;
  margin-bottom: 4px;
}

.subareas-list {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
}

.main-position {
  font-weight: normal;
  font-size: 0.95em;
  color: #555;
  margin-top: 2px;
}
</style>
